
<template>
  <div>
    <div class="contentWrapper" :id="`${tableName}-Wrapper`" @scroll.passive="handleScroll">
      <!-- This div allow to make the scroll function and show the scrollbar -->
      <div   
        :style="{
          width: `${contentWidth}px`,
          overflow: 'scroll',
          height: '0.1px'
        }">
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: ['table_name', 'active_item'],
  data() {
      return {
        tableName: this.table_name,
        contentWidth: 0
      }
    },

    mounted() {
      window.addEventListener("load", (event) => {
        this.setWidth()
    });
    },
    
    watch: {
      active_item: function(newVal, oldVal) { // watch it
        this.setWidth();
      }
  },

  methods: {
    setWidth() {
      // find element
      const element = document.getElementsByClassName("flex-table-"+ this.tableName) [0];
      // check if visible
      const visible = element.offsetParent != null
      // calculate width if visible
      if (element && visible) {
        // get children and calculate maximum width
        const children =element.children;
        let totalWidth = 0;

        for (var i = 0; i < children.length; i++) {
            totalWidth += parseInt(children[i].offsetWidth, 10);
        }

        this.contentWidth = totalWidth;
      }
    },
    handleScroll(event) {
      let tableWrapper = document.querySelector('#table-container-' + this.tableName);

      let hoursWrapper = document.querySelector('#' + this.tableName +'-Wrapper');
      tableWrapper.onscroll = function() {
        hoursWrapper.scrollLeft = tableWrapper.scrollLeft;
      };
        
      hoursWrapper.onscroll = function() {
        tableWrapper.scrollLeft = hoursWrapper.scrollLeft;
      };
    }
  }

}
</script>
